import axios from '../providers/axios';
import apiFiles from '../providers/apiFiles';

export const PERSON_NATURAL = 'natural';
export const PERSON_LEGAL = 'legal';

export const queryOwners = q => axios.get('/owners', { params: { q }});
export const legalOwners = q => axios.get('/owners/legal', { params: { q } });
export const queryAvailableOwners = q => axios.get('/owners/available', { params: { q }});
export const ownerByCPF = cpf => axios.get(`/owners/cpf/${cpf}`);
export const ownerByCNPJ = cnpj => axios.get(`/owners/cnpj/${cnpj}`);
export const ownerById = id => axios.get(`/owners/${id}`);
export const createOwner = data => axios.post('/owners', data);
export const updateOwner = (id, data) => axios.patch(`/owners/${id}`, data);
export const validateOwner = owner => axios.get(`/owners/${owner.id}/complete`);
export const getOwnerCertificates = () => axios.get('/query/custom/certificate-types/carrier');
export const saveCertificate = data => apiFiles.post('/doc', data);

export const ownerSuggestions = q => queryAvailableOwners(q)
  .then(({ data }) => data)
  .catch(() => [ { id: null, description: 'Informe no mínimo duas letras', disabled: true } ]);

export const patchOwner = (id = null, data) => id
  ? updateOwner(id, data)
  : createOwner(data);
